import { render, staticRenderFns } from "./FormatosModalMys.vue?vue&type=template&id=1c495e66&"
import script from "./FormatosModalMys.vue?vue&type=script&lang=js&"
export * from "./FormatosModalMys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports